import application from 'application/application';

application

	.value('applicationsAlias', {
		adviseProducts: {
			name: 'root.default.adviseProducts',
			params: {
				ativo: true
			}
		},
		applications: {
			name: 'root.default.applications',
			params: {}
		},
		cities: {
			name: 'root.default.cities',
			params: {
				ativo: true
			}
		},
		clientUsers: {
			name: 'root.default.clientUsers',
			params: {
				ativoUsuario: true
			}
		},
		clients: {
			name: 'root.default.clients',
			params: {
				ativo: true
			}
		},
		contributors: {
			name: 'root.default.contributors',
			params: {
				ativoUsuario: true
			}
		},
		daily: {
			name: 'root.default.daily',
			params: {
				ativo: true
			}
		},
		departments: {
			name: 'root.default.departments',
			params: {
				ativo: true
			}
		},
		employeeProfiles: {
			name: 'root.default.employeeProfiles',
			params: {
				ativo: true
			}
		},
		federativeUnits: {
			name: 'root.default.federativeUnits',
			params: {
				ativo: true
			}
		},
		menus: {
			name: 'root.default.menus',
			params: {}
		},
		otherwise: {
			name: 'root.default.otherwise',
			params: {}
		},
		plans: {
			name: 'root.default.plans',
			params: {}
		},
		servicesAndFeatures: {
			name: 'root.default.servicesAndFeatures',
			params: {}
		},
		updatePassword: {
			name: 'root.default.updatePassword',
			params: {}
		},
		defaultTypeContactActivity:{
			name: 'root.default.defaultTypeContactActivity',
			params: {
				ativo:true
			}
		},
		typeContactActivity:{
			name: 'root.default.typeContactActivity',
			params: {
				ativo:true
			}
		}
	});
